import { Modal, Spin } from 'antd'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useBoundStore } from '../../../../store/useBoundStore';
import { GET_COUNT_ROWDATA } from './grid/RS-FS-Buckets';
import { REVIEWSCHEDULER, VONBOARDER } from '../../../../utils/Constants';
import axios from '../../../../api';
import { GET_FS_DASHBOARD_CALLS_V5, GET_FS_DASHBOARD_NON_RESPONSIVE_NOT_INTERESTED } from '../../../../utils/Api_enums';

const QuickNavigationModal = ({ visible, onClose, userData, onCardClick }) => {
    const [loading, setLoading] = useState(true);
    const { resetRSFSCardFilters, RSFSCardFilters, setRSFSCardFilters, RSFSFilters } = useBoundStore();
    const [callCounts, setCallCounts] = useState([]);
    const [roles, setRoles] = useState(JSON.parse(localStorage.getItem('roles')));



    const getFSDashboardStats = async () => {
        const hasFollowUp = roles.includes("FollowUp");
        const hasProspect = roles.includes("Prospect");

        let role = null;
        if (hasFollowUp && !hasProspect) {
            role = "FollowUp";
        } else if (!hasFollowUp && hasProspect) {
            role = "Prospect";
        }

        const storeState = useBoundStore.getState();
        const gridFilters = storeState.RSFSFilters;
        const cardFilters = storeState.RSFSCardFilters;

        let type_of_call;
        const agencyId = gridFilters.selectedAgency;
        const from = gridFilters.datemodified.start_date;
        const to = gridFilters.datemodified.end_date;
        const userType = VONBOARDER;

        if (role) {
            type_of_call = role;
        } else {
            type_of_call =
                gridFilters.selectedFilterOption || cardFilters.selectedFilterOption;
        }

        type_of_call = type_of_call === "AllBFiles" ? null : type_of_call;

        const params = {
            from,
            to,
            user_type: userType,
            ...(type_of_call ? { type_of_call } : {}),
            ...(agencyId ? { agency_id: agencyId } : {}),
        };

        const queryString = new URLSearchParams(params).toString();

        const url1 = `${GET_FS_DASHBOARD_CALLS_V5}?${queryString}`;
        const url2 = `${GET_FS_DASHBOARD_NON_RESPONSIVE_NOT_INTERESTED}?${queryString}`;

        try {

            const [res1, res2] = await Promise.all([axios.get(url1), axios.get(url2)]);


            const stats = { ...res1.data, ...res2.data };

            const updatedBuckets = GET_COUNT_ROWDATA(
                RSFSCardFilters.defaultToggleUserRole
            ).map((bucket) => ({
                ...bucket,
                calls: stats[bucket.dashboard_stats] || 0,
            }));

            localStorage.setItem("callCounts", JSON.stringify(updatedBuckets));
            setCallCounts(updatedBuckets);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };





    // const getFSDashboardStats = async () => {
    //     const hasFollowUp = roles.includes("FollowUp");
    //     const hasProspect = roles.includes("Prospect");

    //     let role = null;
    //     if (hasFollowUp && !hasProspect) {
    //         role = "FollowUp";
    //     } else if (!hasFollowUp && hasProspect) {
    //         role = "Prospect";
    //     }


    //     const storeState = useBoundStore.getState();
    //     const gridFilters = storeState.RSFSFilters;
    //     const cardFilters = storeState.RSFSCardFilters;

    //     let type_of_call;
    //     const agencyId = gridFilters.selectedAgency
    //     //  || cardFilters.selectedAgency
    //     const from = gridFilters.datemodified.start_date
    //     // || cardFilters.datemodified.start_date
    //     const to = gridFilters.datemodified.end_date
    //     // || cardFilters.datemodified.end_date
    //     const userType = VONBOARDER;
    //     if (role) {
    //         type_of_call = role
    //     } else {
    //         type_of_call = gridFilters.selectedFilterOption || cardFilters.selectedFilterOption
    //     }

    //     type_of_call = type_of_call == 'AllBFiles' ? null : type_of_call;


    //     const BFILE_API_URL = "api/v2/followup_specialist_dashboard";
    //     const params = {
    //         from,
    //         to,
    //         user_type: userType,
    //         ...(type_of_call ? { type_of_call: type_of_call } : {}),
    //         ...(agencyId ? { agency_id: agencyId } : {})
    //     };
    //     const queryString = new URLSearchParams(params).toString();
    //     const url = `${BFILE_API_URL}?${queryString}`;

    //     await axios.get(url).then(
    //         (response) => {
    //             const stats = response.data;
    //             const updatedBuckets = GET_COUNT_ROWDATA(RSFSCardFilters.defaultToggleUserRole).map((bucket) => ({
    //                 ...bucket,
    //                 calls: stats[bucket.dashboard_stats] || 0,
    //             }));
    //             localStorage.setItem('callCounts', JSON.stringify(updatedBuckets));
    //             setCallCounts(updatedBuckets);
    //             setLoading(false);
    //         },
    //         (error) => {
    //             setLoading(false);
    //         }
    //     );
    // };


    const getRSDashboardStats = async () => {
        try {
            const storeState = useBoundStore.getState();
            const filters = storeState.RSFSCardFilters;
            const rsFSGridFilters = storeState.RSFSFilters;

            const agencyId = filters.selectedAgency
            const from = rsFSGridFilters.datemodified.start_date || filters.datemodified.start_date
            const to = rsFSGridFilters.datemodified.end_date || filters.datemodified.end_date
            const userType = REVIEWSCHEDULER;
            let typeOfCall = filters.selectedFilterOption
            typeOfCall = typeOfCall == 'AllBFiles' ? null : typeOfCall;


            const BFILE_API_URL = "api/rs_user_dashboard_stats";
            const params = {
                from,
                to,
                user_type: userType,
                ...(typeOfCall ? { type_of_call: typeOfCall } : {}),
                ...(agencyId ? { agency_id: agencyId } : {})
            };
            const queryString = new URLSearchParams(params).toString();
            const url = `${BFILE_API_URL}?${queryString}`;

            const response = await axios.get(url);
            const stats = response.data;

            const updatedBuckets = GET_COUNT_ROWDATA(RSFSCardFilters.defaultToggleUserRole).map((bucket) => ({
                ...bucket,
                calls: stats[bucket.dashboard_stats] || 0,
            }));
            localStorage.setItem('callCounts', JSON.stringify(updatedBuckets));
            setCallCounts(updatedBuckets);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error fetching dashboard stats:", error);
        }
    }


    useEffect(() => {
        if (visible) {
            if (RSFSCardFilters.defaultToggleUserRole
                == VONBOARDER) {
                getFSDashboardStats();
            } else {
                getRSDashboardStats();
            }
        }
    }, [visible]);






    // const customOrder = [
    //     "Upcoming Calls",
    //     "Scheduled Appointments",
    //     "Active Calls",
    //     "Non Responsive Calls",
    //     "Not Interested",
    //     "Bad Phone Numbers",
    //     "My Claimed Calls",
    //     "Due Calls",
    //     "Requested To Be Re-Scheduled"
    // ];

    // const sortedCallCounts = [...callCounts].sort((a, b) => {
    //     return customOrder.indexOf(a.title) - customOrder.indexOf(b.title);
    // });



    return (
        <Modal
            title={
                <div>
                    <div style={{ fontSize: '12px' }} className="custom-text-dark">
                        {moment(RSFSFilters.datemodified.start_date ||
                            RSFSCardFilters.datemodified.start_date).format("MM/DD/YYYY")}
                        - {moment(
                            RSFSFilters.datemodified.end_date ||
                            RSFSCardFilters.datemodified.end_date).format("MM/DD/YYYY")}
                    </div>
                </div>
            }
            visible={visible}
            onCancel={onClose}
            footer={null}
            centered
            width="90%"
            style={{
                // maxWidth: '620px',
                maxWidth: '570px',
                margin: '0 auto',
                '@media (max-width: 768px)': {
                    width: '95%',
                    margin: '0 auto'
                }
            }}
            bodyStyle={{
                padding: '20px',
                '@media (max-width: 768px)': {
                    padding: '15px'
                }
            }}
        >
            <Spin spinning={loading}>
                <div className={`popup-card-container ${!loading ? 'loaded' : ''}`}
                    style={{
                        minHeight: '150px',
                        // display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '15px',
                        '@media (max-width: 768px)': {
                            gridTemplateColumns: '1fr',
                            gap: '10px'
                        }
                    }}
                >
                    {callCounts.map((item, idx) => (
                        <div
                            key={idx}
                            className="popup-card hoverable-label"
                            role={item.isClickable ? "button" : undefined}
                            tabIndex={item.isClickable ? 0 : undefined}
                            onClick={() => item.isClickable && onCardClick(item, '')}
                            onKeyDown={(e) => {
                                if (item.isClickable && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    onCardClick(item, '');
                                }
                            }}
                            style={{
                                cursor: item.isClickable ? "pointer" : "default",
                                padding: '15px',
                                '@media (max-width: 768px)': {
                                    padding: '12px'
                                }
                            }}
                            aria-label={item.isClickable ? `Click to view ${item.title || 'item'}` : undefined}
                        >
                            <img src={item.icon} style={{ maxHeight: "16px", marginRight: '8px' }} />
                            <span className="popup-card-title-style">{item.title}:</span>
                            <span
                                className="popup-card-highlight-text"
                                style={{ textDecoration: item.isClickable ? "underline" : "none" }}
                            >
                                {item.calls}
                            </span>
                        </div>
                    ))}
                </div>
            </Spin>
        </Modal>
    )
}

export default QuickNavigationModal



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/QuickNavigationModal.js